

export class TransactionApplicationDto implements ITransactionApplicationDto {
    tenantId!: number | undefined;
    id!: number | undefined;
    employeeCode!: number | undefined;
    employeeIds!: number[] | undefined;
    companyIds!: number[] | undefined;
    mobileNo!: string | undefined;
    fromDate!: Date | undefined;
    toDate!: Date | undefined;
    fromMonth!: string | undefined;
    toMonth!: string | undefined;
    gender!: string | undefined;
    branchIds!: number[] | undefined;
    departmentIds!: number[] | undefined;
    designationIds!: number[] | undefined;
    approverIds!: number[] | undefined;
    employeeStatus!: number | undefined;
    applicationStatus!: number | undefined;
    locationIds!: number[] | undefined;
    employee_Type!: number | undefined;
    financialYear!: string[] | undefined;
    slabTypeId!: number[] | undefined;
    itMethodId!: number[] | undefined;

    constructor(data?: ITransactionApplicationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tenantId = _data["tenantId"];
            this.id = _data["id"];
            this.employeeCode = _data["employeeCode"];
            if (Array.isArray(_data["employeeIds"])) {
                this.employeeIds = [] as any;
                for (let item of _data["employeeIds"])
                    this.employeeIds!.push(item);
            }
            if (Array.isArray(_data["companyIds"])) {
                this.companyIds = [] as any;
                for (let item of _data["companyIds"])
                    this.companyIds!.push(item);
            }
            this.mobileNo = _data["mobileNo"];
            this.fromDate = _data["fromDate"] ? new Date(_data["fromDate"].toString()) : <any>undefined;
            this.toDate = _data["toDate"] ? new Date(_data["toDate"].toString()) : <any>undefined;
            this.fromMonth = _data["fromMonth"];
            this.toMonth = _data["toMonth"];
            this.gender = _data["gender"];
            if (Array.isArray(_data["branchIds"])) {
                this.branchIds = [] as any;
                for (let item of _data["branchIds"])
                    this.branchIds!.push(item);
            }
            if (Array.isArray(_data["departmentIds"])) {
                this.departmentIds = [] as any;
                for (let item of _data["departmentIds"])
                    this.departmentIds!.push(item);
            }
            if (Array.isArray(_data["designationIds"])) {
                this.designationIds = [] as any;
                for (let item of _data["designationIds"])
                    this.designationIds!.push(item);
            }
            if (Array.isArray(_data["approverIds"])) {
                this.approverIds = [] as any;
                for (let item of _data["approverIds"])
                    this.approverIds!.push(item);
            }
            this.employeeStatus = _data["employeeStatus"];
            this.applicationStatus = _data["applicationStatus"];
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            this.employee_Type = _data["employee_Type"];
            if (Array.isArray(_data["financialYear"])) {
                this.financialYear = [] as any;
                for (let item of _data["financialYear"])
                    this.financialYear!.push(item);
            }
            if (Array.isArray(_data["slabTypeId"])) {
                this.slabTypeId = [] as any;
                for (let item of _data["slabTypeId"])
                    this.slabTypeId!.push(item);
            }
            if (Array.isArray(_data["itMethodId"])) {
                this.itMethodId = [] as any;
                for (let item of _data["itMethodId"])
                    this.itMethodId!.push(item);
            }
        }
    }

    static fromJS(data: any): TransactionApplicationDto {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionApplicationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["id"] = this.id;
        data["employeeCode"] = this.employeeCode;
        if (Array.isArray(this.employeeIds)) {
            data["employeeIds"] = [];
            for (let item of this.employeeIds)
                data["employeeIds"].push(item);
        }
        if (Array.isArray(this.companyIds)) {
            data["companyIds"] = [];
            for (let item of this.companyIds)
                data["companyIds"].push(item);
        }
        data["mobileNo"] = this.mobileNo;
        data["fromDate"] = this.fromDate ? this.fromDate.toISOString() : <any>undefined;
        data["toDate"] = this.toDate ? this.toDate.toISOString() : <any>undefined;
        data["fromMonth"] = this.fromMonth;
        data["toMonth"] = this.toMonth;
        data["gender"] = this.gender;
        if (Array.isArray(this.branchIds)) {
            data["branchIds"] = [];
            for (let item of this.branchIds)
                data["branchIds"].push(item);
        }
        if (Array.isArray(this.departmentIds)) {
            data["departmentIds"] = [];
            for (let item of this.departmentIds)
                data["departmentIds"].push(item);
        }
        if (Array.isArray(this.designationIds)) {
            data["designationIds"] = [];
            for (let item of this.designationIds)
                data["designationIds"].push(item);
        }
        if (Array.isArray(this.approverIds)) {
            data["approverIds"] = [];
            for (let item of this.approverIds)
                data["approverIds"].push(item);
        }
        data["employeeStatus"] = this.employeeStatus;
        data["applicationStatus"] = this.applicationStatus;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["employee_Type"] = this.employee_Type;
        if (Array.isArray(this.financialYear)) {
            data["financialYear"] = [];
            for (let item of this.financialYear)
                data["financialYear"].push(item);
        }
        if (Array.isArray(this.slabTypeId)) {
            data["slabTypeId"] = [];
            for (let item of this.slabTypeId)
                data["slabTypeId"].push(item);
        }
        if (Array.isArray(this.itMethodId)) {
            data["itMethodId"] = [];
            for (let item of this.itMethodId)
                data["itMethodId"].push(item);
        }
        return data; 
    }
}

export interface ITransactionApplicationDto {
    tenantId: number | undefined;
    id: number | undefined;
    employeeCode: number | undefined;
    employeeIds: number[] | undefined;
    companyIds: number[] | undefined;
    mobileNo: string | undefined;
    fromDate: Date | undefined;
    toDate: Date | undefined;
    fromMonth: string | undefined;
    toMonth: string | undefined;
    gender: string | undefined;
    branchIds: number[] | undefined;
    departmentIds: number[] | undefined;
    designationIds: number[] | undefined;
    approverIds: number[] | undefined;
    employeeStatus: number | undefined;
    applicationStatus: number | undefined;
    locationIds: number[] | undefined;
    employee_Type: number | undefined;
    financialYear: string[] | undefined;
    slabTypeId: number[] | undefined;
    itMethodId: number[] | undefined;
}

